import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { isCheckinReturnUrl } from '../../self-checkin/self-checkin-flow.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../auth.service';
import { Activation } from './activation.model';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-activation',
    templateUrl: './activation.component.html',
    styleUrls: ['./activation.component.scss'],
    standalone: false
})
export class ActivationComponent implements OnInit {
  isLoading: boolean = false;
  token: string = '';
  email: string = '';
  tenantSubdomain: string = '';
  activationSuccess: boolean = false;
  activationFailure: boolean = false;
  private sub: any;
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private tenantService: TenantService
  ) {}
  ngOnInit(): void {
    this.isLoading = true;
    const activationData: Activation = {
      email: this.route.snapshot.params['email'],
      token: this.route.snapshot.params['token'],
    };
    this.tenantSubdomain = this.tenantService.getTenant();
    this.authService.validate(activationData).subscribe(
      (data) => {
        this.authService.checkinDevices.save(data.userId, data.checkinDeviceToken);
        const target = sessionStorage.getItem('CSCheckinReturn:' + this.tenantSubdomain);
        if (isCheckinReturnUrl(target, this.tenantSubdomain)) void this.router.navigateByUrl(target);
        this.activationSuccess = true;
        this.isLoading = false;
      },
      (errorMessage) => {
        this.activationFailure = true;
        this.isLoading = false;
      }
    );
  }

  getDomain() {
    if (environment.production == false)
      return "church-services-staging";
    return "church-services";
  }
}
